// Sprint 17 A8: Hook for pipeline AI indicators
import { useState, useEffect } from "react";
import { apiFetch } from "@/lib/api-client";

export interface StageMetrics {
  stageId: string;
  stageName: string;
  dealCount: number;
  totalValue: number;
  weightedValue: number;
  avgDaysInStage: number;
  conversionRate: number;
  isBottleneck: boolean;
}

export interface PipelineSummary {
  stages: StageMetrics[];
  totalPipelineValue: number;
  avgCycleTimeDays: number;
  overallWinRate: number;
  aiSummary: string;
}

export function usePipelineAI(pipelineId: string | undefined) {
  const [data, setData] = useState<PipelineSummary | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!pipelineId) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    apiFetch<{ data: PipelineSummary }>(`/crm/deals/pipeline-summary?pipelineId=${encodeURIComponent(pipelineId)}`)
      .then((res) => {
        if (res.data?.stages && Array.isArray(res.data.stages)) {
          setData(res.data);
        }
      })
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load"))
      .finally(() => setIsLoading(false));
  }, [pipelineId]);

  return { data, isLoading, error };
}
